import { handleResponse, handleError } from "../../services/apiUtils";
import { resetInactivityTimer } from "../../services/inactivityTimer";
import { Configuration } from "./types";

export const get = async (): Promise<Configuration | undefined> => {
    try {
        resetInactivityTimer();
        const response = await fetch("/api/configuration/clientConfiguration");
        return handleResponse(response);
    } catch (error) {
        handleError(error);
    }
};
